import { createFormHook } from '@tanstack/react-form';
import { PaymentSettingsFormFields } from './form-fields';
import {
  fieldContext,
  formContext,
} from './payment-settings-form-context.hook';

const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: PaymentSettingsFormFields.TextField,
    NumberField: PaymentSettingsFormFields.NumberField,
    CheckboxField: PaymentSettingsFormFields.CheckboxField,
    SelectField: PaymentSettingsFormFields.SelectField,
    RadioCardField: PaymentSettingsFormFields.RadioCardField,
  },
  formComponents: {},
});

export { useAppForm as usePaymentSettingsForm };
